import React from 'react';
import { XMarkIcon, TagIcon } from '@heroicons/react/24/outline';

const BulkActionsBar = ({ selectedCount, onActivate, onDeactivate, onDelete, onAssignBrand, onCancel, loading }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 animate-in slide-in-from-top">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="text-sm font-medium text-blue-900">
            נבחרו {selectedCount} מוצרים
          </span>
        </div>

        <div className="flex gap-2">
          {onAssignBrand && (
            <button
              onClick={onAssignBrand}
              disabled={loading}
              className="px-4 py-2 bg-purple-600 text-white text-sm font-medium rounded-lg hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-2"
            >
              <TagIcon className="h-4 w-4" />
              שייך למותג
            </button>
          )}
          <button
            onClick={onActivate}
            disabled={loading}
            className="px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            הפעל
          </button>
          <button
            onClick={onDeactivate}
            disabled={loading}
            className="px-4 py-2 bg-yellow-600 text-white text-sm font-medium rounded-lg hover:bg-yellow-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            השבת
          </button>
          <button
            onClick={onDelete}
            disabled={loading}
            className="px-4 py-2 bg-red-600 text-white text-sm font-medium rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            מחק
          </button>
          <button
            onClick={onCancel}
            disabled={loading}
            className="px-4 py-2 border border-gray-300 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-2"
          >
            <XMarkIcon className="h-4 w-4" />
            ביטול
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;

